module.exports = __webpack_public_path__ + "assets/img/price-sm.5d50b36d.jpg";